import React from 'react'
import {useDispatch, useSelector} from "react-redux"
import {Link} from "react-router-dom"

import {AppBar, Typography, Toolbar} from '@material-ui/core'
import {Drawer, Divider, IconButton} from '@material-ui/core'
import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core'
import IconHistory from '@material-ui/icons/AccessTime'
import IconAccount from '@material-ui/icons/AccountCircle'
import IconContact from '@material-ui/icons/MailOutlined'
import IconNewAnalysis from '@material-ui/icons/CreditCard'
import IconLogout from '@material-ui/icons/ExitToApp'
import IconFAQ from '@material-ui/icons/HelpOutline'
import MenuIcon from '@material-ui/icons/Menu'
import Stack from '@mui/material/Stack'

import {useStyles} from '../../themes/styles'

const Header = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const [state, setState] = React.useState({
    drawerOpen: false,
  })

  const toggleDrawer = (newState) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setState({ ...state, drawerOpen: newState })
  }

  const list = () => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem button component={Link} to="/purchase">
          <ListItemIcon><IconNewAnalysis/></ListItemIcon>
          <ListItemText primary="Purchase"/>
        </ListItem>
        <ListItem button component={Link} to="/faq">
          <ListItemIcon><IconFAQ className={classes.clickBlack}/></ListItemIcon>
          <ListItemText primary="FAQ" />
        </ListItem>
        <ListItem button component={Link} to="/contact">
          <ListItemIcon><IconContact className={classes.clickBlack}/></ListItemIcon>
          <ListItemText primary="Contact Us" />
        </ListItem>
      </List>
    </div>
  )

  return ( <>
    <Drawer anchor="left" open={state["drawerOpen"]} onClose={toggleDrawer(false)}>
      {list()}
    </Drawer>
    <AppBar position="static" width="100%">
      <Toolbar>
        <IconButton onClick={toggleDrawer(true)} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
          <MenuIcon />
        </IconButton>
        <Typography variant="h5" className = {classes.rootHeader}>
          <Link to="/" className={classes.linkStyle}>
            Our Story Song
          </Link>
        </Typography>
      </Toolbar>
    </AppBar>
  </> )
}

export default Header
